<template>
  <div>
    <v-card id="admin-imports" class="px-5 py-2 mt-4 mb-5 elevation-0">
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        sort-by="createdAt"
        :sort-desc="true"
        class="admin-imports-table elevation-0 mt-2"
        mobile-breakpoint="0"
        :loading="loading"
        :footer-props="{
          'items-per-page-options': defaultPaginationItemsPerPageOptions,
        }"
        :items-per-page="20"
        dense
        @update:options="loadItems"
      >
        <template v-slot:item.broker="{ item }">
          <span v-if="item.broker">
            {{ item.broker.code }}
          </span>
        </template>

        <template v-slot:item.error="{ item }">
          <span v-if="item.error">
            {{ item.error.message }}
          </span>
        </template>

        <template v-slot:item.successElements="{ item }">
          <span v-if="item.result && item.result.summary" class="softGreen--text">
            <b>{{ item.result.summary.successElements }}</b>
          </span>
        </template>

        <template v-slot:item.errorElements="{ item }">
          <span
            v-if="item.result && item.result.summary && item.result.summary.errorElements"
            class="softRed--text"
          >
            <b>{{ item.result.summary.errorElements }}</b>
          </span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { adminGetImports } from '@/lib/api.js'
import tableMixin from '@/views/components/core/tableMixin.js'

export default {
  mixins: [tableMixin],
  data: () => ({}),
  computed: {
    defaultHeaders() {
      return [
        {
          text: 'userId',
          value: 'userId',
        },
        {
          text: 'createdAt',
          value: 'createdAt',
        },
        {
          text: 'broker',
          value: 'broker',
        },
        {
          text: 'type',
          value: 'type',
        },
        {
          text: 'status',
          value: 'status',
        },
        {
          text: 'successElements',
          value: 'successElements',
        },
        {
          text: 'errorElements',
          value: 'errorElements',
        },
        {
          text: 'error',
          value: 'error',
        },
      ]
    },
  },
  methods: {
    async loadItems() {
      this.loading = true
      try {
        const filter = {}
        const { page, limit, sort } = this.getTablePaginationOptions(this.options)
        const response = await adminGetImports({ filter, page, limit, sort })
        this.setTablePaginatedResponse(response)
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }
      this.loading = false
    },
  },
}
</script>
